import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ScheduleEmbed({ children }) {
    const { target } = useBoundContext()
    const Component = children.type

    return <Component key={target?._id} {...children.props} schedule={target} />
}
